import { Capacitor } from "@capacitor/core";
import androidDownload from "@/config/androidDownload.json";

export default function DownloadSection() {
  if (Capacitor.isNativePlatform()) return null;
  let url = "";
  try {
    const target = new URL(process.env.REACT_APP_ANDROID_DOWNLOAD_URL || androidDownload.url);
    if (target.protocol === "https:" && !target.username && !target.password) url = target.href;
  } catch { /* No download URL configured. */ }
  if (!url) return null;
  return <div className="flex justify-center py-1 text-center" data-testid="download-section">
    <a href={url} target="_blank" rel="noopener noreferrer" data-testid="android-download-link" className="inline-block text-center text-sm font-medium text-blue-600 underline underline-offset-2 hover:text-blue-700">
      Download BudgetPulse App
    </a>
  </div>;
}
